if(navigator.userAgent.indexOf("Chrome-Lighthouse") == -1) { $(document).ready(function(){
    var $cartBtn = $('#ViewCart');
    if($cartBtn.length){
        $cartBtn.on('click', function(event){
            event.preventDefault();
            window.location.href = '/cart';
        });
    }

    var $newsletterForm = $('#mc-embedded-subscribe-form');
    var $newsletterBtn = $('#subscribe-btn');
    if($newsletterForm.length && $newsletterBtn.length) {
        $newsMessagesWrapper = $('#newsletter-messages-wrapper');
        $newsletterBtn.on('click', function(event){
            event.preventDefault();
            $.ajax({
                type: $newsletterForm.attr('method'),
                url: $newsletterForm.attr('action'),
                data: $newsletterForm.serialize(),
                cache       : false,
                dataType    : 'json',
                contentType: "application/json; charset=utf-8",
                error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
                success     : function(data) {
                    $newsMessagesWrapper.html('');
                    if (data.result == "success") {
                        $newsMessagesWrapper.addClass('alert alert--success').removeClass('alert--error');
                    } else {
                        $newsMessagesWrapper.addClass('alert alert--error').removeClass('alert--success');
                    }
                    if(data.msg !== ''){
                        $newsMessagesWrapper.html(data.msg);
                      	$newsMessagesWrapper.show();
                    }

                    setTimeout(function(){
                        $newsMessagesWrapper.slideUp();
                        $newsMessagesWrapper.removeClass('alert');
                    },3000);
                }
            });
        })
    }
  
  //
  $(".template-cart .quantity__minus, .template-cart .quantity__plus").on("click", function() {
    event.preventDefault();
    var $button = $(this);
    var oldValue = $button.closest().find("input").val();
    console.log('clicked' + oldValue);
    
   /* if ($button.text() == "+") {
        var newVal = parseFloat(oldValue) + 1;
      } else {
     // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }

    $button.parent().find("input").val(newVal);*/

  });
});


                                                           }